import tw, { styled } from 'twin.macro';

import Icon from '@/components/Icon/IconSprite';

export const StyledInputContainer = styled.div`
  ${tw`relative`}
  ${tw`flex flex-col`}
`;

export const StyledInput = styled.input<{ hasError: boolean }>`
  ${tw`outline-none`}
  ${tw`px-2 py-[12px] gap-1`}
  ${tw`flex items-center shrink-0 self-stretch`}
  ${tw`rounded-[8px]`}
  ${tw`border border-ui-colours-ui3 focus:border-ui-colours-ui3`}
  ${tw`bg-neutrals-n1`}
  ${tw`leading-6`}
  ${tw`font-inter font-regular`}
  ${tw`text-primary-p1`}

  ::placeholder {
    ${tw`flex flex-col justify-center self-stretch grow shrink-0 basis-0`}
    ${tw`text-mobile-heading-xxs text-neutrals-n7`}
  }

  &:focus,
  &:active {
    ::placeholder {
      ${tw`text-primary-p1`}
    }
  }

  ${({ hasError }) => hasError && [tw`border-primary-p2 bg-ui-colours-ui4`]}
  ${({ disabled }) => disabled && tw`cursor-not-allowed opacity-50`}}

`;

export const StyledErrorIcon = styled(Icon)`
  ${tw`absolute top-[50%] right-[12px]`}
  ${tw`font-inter font-medium`}
  ${tw`text-body-s text-primary-p2`}
  ${tw`w-[24px] h-[24px]`}
  ${tw`transform -translate-y-1/2`}
`;
